// Telegram WebApp SDK Integration Helper

declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        ready: () => void;
        expand: () => void;
        close: () => void;
        enableClosingConfirmation: () => void;
        isExpanded: boolean;
        viewportHeight: number;
        viewportStableHeight: number;
        headerColor: string;
        backgroundColor: string;
        setHeaderColor: (color: string) => void;
        setBackgroundColor: (color: string) => void;
        MainButton: {
          text: string;
          color: string;
          textColor: string;
          isVisible: boolean;
          isActive: boolean;
          isProgressVisible: boolean;
          setText: (text: string) => void;
          onClick: (fn: () => void) => void;
          offClick: (fn: () => void) => void;
          show: () => void;
          hide: () => void;
          enable: () => void;
          disable: () => void;
          showProgress: (leaveActive?: boolean) => void;
          hideProgress: () => void;
        };
        BackButton?: {
          isVisible: boolean;
          onClick: (fn: () => void) => void;
          offClick: (fn: () => void) => void;
          show: () => void;
          hide: () => void;
        };
        HapticFeedback: {
          impactOccurred: (style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft') => void;
          notificationOccurred: (type: 'error' | 'success' | 'warning') => void;
          selectionChanged: () => void;
        };
        showAlert: (message: string, callback?: () => void) => void;
        showConfirm: (message: string, callback?: (confirmed: boolean) => void) => void;
        initData: string;
        initDataUnsafe: {
          user?: {
            id: number;
            first_name: string;
            last_name?: string;
            username?: string;
          };
          query_id?: string;
        };
      };
    };
  }
}

export const tg = {
  isAvailable: () => typeof window !== 'undefined' && !!window.Telegram?.WebApp,
  getApp: () => window.Telegram?.WebApp,
  ready: () => {
    try {
      window.Telegram?.WebApp?.ready();
      window.Telegram?.WebApp?.expand();
      window.Telegram?.WebApp?.enableClosingConfirmation();
    } catch {}
  },
  haptic: {
    impact: (style: 'light' | 'medium' | 'heavy' = 'light') => {
      try {
        window.Telegram?.WebApp?.HapticFeedback.impactOccurred(style);
      } catch {}
    },
    success: () => {
      try {
        window.Telegram?.WebApp?.HapticFeedback.notificationOccurred('success');
      } catch {}
    },
    warning: () => {
      try {
        window.Telegram?.WebApp?.HapticFeedback.notificationOccurred('warning');
      } catch {}
    },
    error: () => {
      try {
        window.Telegram?.WebApp?.HapticFeedback.notificationOccurred('error');
      } catch {}
    },
    selectionChanged: () => {
      try {
        window.Telegram?.WebApp?.HapticFeedback.selectionChanged();
      } catch {}
    },
  },
  alert: (message: string, callback?: () => void) => {
    if (window.Telegram?.WebApp?.showAlert) {
      window.Telegram.WebApp.showAlert(message, callback);
    } else {
      alert(message);
      callback?.();
    }
  },
  confirm: (message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      if (window.Telegram?.WebApp?.showConfirm) {
        window.Telegram.WebApp.showConfirm(message, (res) => resolve(res));
      } else {
        resolve(window.confirm(message));
      }
    });
  },
  backButton: {
    show: (onClick: () => void) => {
      try {
        const bb = window.Telegram?.WebApp?.BackButton;
        if (bb) {
          bb.onClick(onClick);
          bb.show();
        }
      } catch {}
    },
    hide: () => {
      try {
        const bb = window.Telegram?.WebApp?.BackButton;
        if (bb) {
          bb.hide();
        }
      } catch {}
    },
  },
};
